import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement } from 'chart.js';

// Register necessary chart.js components
ChartJS.register(LineElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement);

const LineChart = ({ utilizationData }) => {
  // Extract all sanctionedLimit and maxUtilization values from the utilization array
  const sanctionedLimits = utilizationData.map(item => parseFloat(item.sanctionedLimit));
  const maxUtilizations = utilizationData.map(item => parseFloat(item.maxUtilization));

  const data = {
    // labels: sanctionedLimits.map((_, idx) => `Data ${idx + 1}`), // Generate X-axis labels dynamically
    datasets: [
        {
          label: 'Max Util',
          data: maxUtilizations,
          borderColor: 'rgba(88, 80, 236, 1)',
          backgroundColor: 'rgba(88, 80, 236, 1)', // Fill color
          pointBackgroundColor: 'rgba(88, 80, 236, 1)',
          pointBorderColor: '#fff', // Point border color
          pointBorderWidth: 2,
          pointRadius: 5, // Point size
          borderWidth: 2,
          tension: 0, // Curve of the line (smoother)
        },
        {
            label: 'Sanction Limit',
            data: sanctionedLimits,
            borderColor: 'rgba(255, 159, 64, 1)',
            backgroundColor: 'rgba(242, 160, 8, 1)', // Fill color
            pointBackgroundColor: 'rgba(255, 159, 64, 1)',
            pointBorderColor: '#fff', // Point border color
            pointBorderWidth: 2,
            pointRadius: 5, // Point size
            borderWidth: 2,
            tension: 0, // Curve of the line (smoother)
        },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          usePointStyle: false,
          padding: 20,
        },
        onClick: (e, legendItem, legend) => {
            const chartInstance = legend.chart;
            const datasetIndex = legendItem.datasetIndex;
  
            // Get references to both datasets
            const sanctionedMeta = chartInstance.getDatasetMeta(0);
            const maxUtilMeta = chartInstance.getDatasetMeta(1);
  
            // Toggle the clicked dataset and ensure only one is visible
            if (datasetIndex === 0) {
              // Toggle Sanction Limit
              sanctionedMeta.hidden = false;
              maxUtilMeta.hidden = true;
            } else {
              // Toggle Max Util
              sanctionedMeta.hidden = true;
              maxUtilMeta.hidden = false;
            }
  
            chartInstance.update();
        },
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Entries',
        },
      },
      y: {
        title: {
          display: false,
          text: 'Amount',
        },
        ticks: {
          callback: function (value) {
            return value.toLocaleString(); // Format Y-axis values
          },
        },

        tooltip: {
            callbacks: {
              label: function (context) {
                let value = context.raw || 0;
                return `₹: ${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`; // Format in INR
              },
            },
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
